export default __webpack_public_path__ + "static/img/vogue_scene_animated_0646.dfd39a2.webp";